
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"13","height":"13","rx":"6.5","stroke":"#D5DBE3"}}),_c('rect',{attrs:{"x":"3","y":"3","width":"8","height":"8","rx":"4","fill":"#D5DBE3"}})])
          )
        }
      }
    